export function renderSearchResults(target, html, append = false) {
  const parsed = new DOMParser().parseFromString(html, "text/html")
  if (!append) { target.replaceChildren(...parsed.body.childNodes); return }
  const grid = target.querySelector(".search-source-grid")
  if (!grid) { target.replaceChildren(...parsed.body.childNodes); return }
  const identities = new Set([...grid.querySelectorAll("[data-search-identity]")].map(node => node.dataset.searchIdentity))
  parsed.querySelectorAll("[data-search-identity]").forEach(node => {
    if (!identities.has(node.dataset.searchIdentity)) { grid.append(node); identities.add(node.dataset.searchIdentity) }
  })
  target.querySelector("nav")?.remove()
  const nav = parsed.querySelector("nav")
  nav?.querySelectorAll('[data-search-page]')?.forEach(link => { if (link.textContent === "Previous") link.remove() })
  if (nav) target.append(nav)
  const count = target.querySelector(".search-result-count")
  if (count) {
    const total = count.dataset.total
    count.textContent = `${total} ${Number(total) === 1 ? "result" : "results"}`
  }
}
